import { commentItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-4xl">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-3">
            读者热评
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            来看看吃瓜群众们都在聊些什么
          </p>
        </div>

        <div className="space-y-4">
          {commentItems.map((item) => (
            <div
              key={item.id}
              className="flex gap-4 p-4 md:p-5 bg-background-100 rounded-xl border border-background-200/70"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 rounded-full overflow-hidden flex-shrink-0">
                <img
                  src={item.avatar}
                  alt={item.nickname}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-3 mb-1.5 flex-wrap">
                  <span className="text-sm font-semibold text-foreground-900">
                    {item.nickname}
                  </span>
                  <span className="text-xs text-foreground-400">{item.time}</span>
                </div>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-2">
                  {item.content}
                </p>
                <div className="flex items-center gap-4 text-xs text-foreground-400">
                  <button className="flex items-center gap-1 hover:text-primary-500 transition-colors cursor-pointer bg-transparent border-none p-0">
                    <i className="ri-thumb-up-line"></i>
                    <span>{item.likes.toLocaleString()}</span>
                  </button>
                  <button className="flex items-center gap-1 hover:text-primary-500 transition-colors cursor-pointer bg-transparent border-none p-0">
                    <i className="ri-chat-1-line"></i>
                    <span>回复</span>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <span className="text-sm text-foreground-500">
            以上为精选读者评论，仅代表用户个人观点
          </span>
        </div>
      </div>
    </section>
  );
}